import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AbstractControl, FormControl} from '@angular/forms';
import {debounceTime, startWith, switchMap} from 'rxjs/operators';
import {Observable, Subject, Subscription} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {KeyValueDto} from '../../../@services/gen';

@Component({
  selector: 'app-ng-material-single-form',
  templateUrl: './ng-material-single-form.component.html',
  styleUrls: ['./ng-material-single-form.component.scss'],
})
export class NgMaterialSingleFormComponent implements OnInit {
  // Note: Use '__' to represent relation column. Example: posItemUnit__id
  @Input() control: AbstractControl = new FormControl();
  @Input() label = '';
  @Input() value = '';
  @Input() class = '';
  @Input() type?;
  @Input() formField = '';
  @Input() options: KeyValueDto[];
  @Input() api: string;
  @Input() params: any;
  @Input() disabled?: boolean = false;
  @Input() placeholder?: string = '';
  @Input() suffix?: string;
  @Output() callParentEvent = new EventEmitter();
  @Output() change = new EventEmitter();

  // single or multiple
  @Input() autoCompleteSelectionType?;

  loadingAutocomplete = false;
  autocompleteList;
  subjectAutocomplete = new Subject();
  subs: Subscription[] = [];
  defaultValue = '';
  hide = true;
  timeValue;

  ngOnInit(): void {
    if (this.formField == 'autocomplete') {
      this.getAutocomplete();
    }
    if (this.formField == 'dropdown' && this.api != null) {
      this.subscribeOptionsApi();
    }
    if (this.formField == 'dropdown-select' && this.api != null) {
      this.subscribeOptionsApi();
    }
    if (this.formField == 'radio' && this.api != null) {
      this.subscribeOptionsApi();
    }

    if (this.formField != 'timepicker') {
      if (this.disabled) {
        this.control.disable();
      } else {
        this.control.enabled;
      }
    }
  }
  constructor(private http: HttpClient) {}

  hasFieldError(): boolean {
    if (!this.control) {
      return;
    }

    if (
      this.formField == 'dropdown' &&
      this.control.invalid &&
      (this.control.dirty || this.control.touched) &&
      this.control.value == 0
    ) {
      this.control.setErrors({invalid: true});
      return true;
    }

    if (
      this.formField == 'autocomplete' &&
      this.control.invalid &&
      (this.control.dirty || this.control.touched) &&
      this.control.hasError('required')
    ) {
      this.control.setErrors({invalid: true});
      return true;
    }

    return this.control.invalid && (this.control.dirty || this.control.touched);
  }

  searchAutocomplete(event) {
    this.loadingAutocomplete = true;
    this.autocompleteList = [];
    this.subjectAutocomplete.next(event.target.value);
  }

  changeAutocomplete(data: any, evt?: any) {
    if (!evt || evt.isUserInput) {
      this.control.patchValue(data.value, {emitEvent: false});

      if (this.autoCompleteSelectionType == 'multiple') {
        this.callParentEvent.emit(data);
      }
    }
  }

  getAutocomplete(): any {
    this.subs.push(
      this.subjectAutocomplete
        .pipe(
          startWith(''),
          debounceTime(400),
          switchMap((val: string) => {
            return this.loadData(this.api, val);
          })
        )
        .subscribe((content) => {
          if (content) {
            this.autocompleteList = content;
          }

          this.loadingAutocomplete = false;
        })
    );
  }

  loadData(url, search: string): Observable<any[]> {
    let command = {
      searchTerm: search,
    };
    command = Object.assign({}, command, this.params);
    return this.http.post<any>(url, command);
  }

  convertNumber(key) {
    if (isNaN(key)) {
      return key;
    } else {
      return +key;
    }
  }

  subscribeOptionsApi() {
    this.getOptionsApi().subscribe((x: KeyValueDto[]) => {
      this.options = x;
    });
  }
  getOptionsApi(): Observable<any> {
    let command = {
      searchTerm: '',
    };
    command = Object.assign({}, command, this.params);
    return this.http.post<KeyValueDto[]>(this.api, command);
  }

  changeOption(evt?: any) {
    this.change.emit(evt);
  }

  selectAll(fcontrol: FormControl) {
    const allOptionValues = this.options.map((opt) => this.convertNumber(opt.key));
    const currentValues = fcontrol.value;

    if (!this.isAllSelected(fcontrol)) {
      const updatedValues = [...currentValues, ...allOptionValues];
      fcontrol.patchValue(updatedValues);
    } else {
      const updatedValues = currentValues.filter((value) => !allOptionValues.includes(value));
      fcontrol.patchValue(updatedValues);
    }
  }

  isAllSelected(fcontrol: FormControl) {
    const selectedValues = fcontrol.value;
    const allOptionValues = this.options.map((opt) => this.convertNumber(opt.key));

    return selectedValues && selectedValues.length === allOptionValues.length;
  }

  setTimePicker(event: any) {
    console.log(this.timeValue);
    this.change.emit(event);
  }
}
